var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1901 21.2004C83.5701 21.1504 70.9501 21.0904 58.3301 21.0404C97.6801 79.8004 137.04 138.57 176.39 197.33H214.22L96.1901 21.2004Z",
    fill: "#29A063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.84 197.33L146.53 229.36H184.9L214.22 197.33H175.84Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.07 21.0404L188.54 57.7104L52.48 226.36L26.51 189.38L162.07 21.0404Z",
    fill: "#B2E8C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.32 23.3204L224.63 59.9805L188.54 57.7104L161.88 21.1804L201.32 23.3204Z",
    fill: "#29A063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.53 57.7104L224.63 59.9805C181.03 115.18 137.44 170.38 93.84 225.58C80.05 225.84 66.27 226.1 52.48 226.36C97.83 170.14 143.18 113.93 188.53 57.7104Z",
    fill: "#72D09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.25 130.11C156.44 129.82 143.64 129.53 130.83 129.24C146.02 151.94 161.2 174.64 176.39 197.34H214.22C199.23 174.93 184.24 152.52 169.25 130.11Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.33 21.0404L29.01 53.0704L147.04 229.2L176.36 197.17L58.33 21.0404Z",
    fill: "#B2E8C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNon);
export default __webpack_public_path__ + "static/media/non.8b64c6de330268b7f89743984906b535.svg";
export { ForwardRef as ReactComponent };